<div>
  <form [formGroup]="inputForm">
    <label [for]="button?.button_id">{{ button?.button_label }}</label>
    <p *ngIf="button?.button_sublabel" class="text-muted">
      {{ button?.button_sublabel }}
    </p>
    <select
      class="form-select input-rounded input-focus-border"
      formControlName="value"
      [ngClass]="{ 'is-invalid': f.value.errors }"
      (change)="onChange()"
    >
      <option *ngFor="let item of options" [value]="item.id">
        {{ item.label }}
      </option>
    </select>
    <div *ngIf="f.value.errors" class="invalid-feedback">
      <div *ngIf="f.value.errors.required">
        {{ errorMsgList["required"] }}
      </div>
      <div *ngIf="f.value.errors.minlength">
        {{ errorMsgList["minlength"] }}
      </div>
      <div *ngIf="f.value.errors.maxlength">
        {{ errorMsgList["maxlength"] }}
      </div>
      <div *ngIf="f.value.errors.pattern">
        {{ errorMsgList["pattern"] }}
      </div>
    </div>
  </form>
</div>
